import React from "react";
import { ReactController } from "../react_controller";
import { AdminEventsCalendar } from "../../components/Calendar/AdminEventsCalendar";

export class AdminEventsCalendarController extends ReactController {
  connect() {
    this.root.render(<AdminEventsCalendar {...this.propsValue} />);
  }
}
